import { useEffect } from 'react'
import { To, useLocation, useNavigate } from 'react-router-dom'
import { App, BackButtonListenerEvent } from '@capacitor/app'

interface UseBackButtonProps {
  onBack?: VoidFunction
  backRoute?: To
}

export const useBackButton = ({ onBack, backRoute }: UseBackButtonProps = {}) => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    App.addListener('backButton', (_: BackButtonListenerEvent) => {
      onBack?.()

      if (backRoute) {
        navigate((backRoute ? backRoute : -1) as To)
        return
      }

      App.exitApp()
    })
  }, [location.key, navigate, backRoute, onBack])
}
